// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_id-0";
export var animationContainer = "_id-1";
export var modalContent = "_id-2";
export var orderName = "_id-3";
export var refundOption = "_id-4";
export var refundOptionsContainer = "_id-5";